import React, { useEffect, useState } from "react";
import { ethers } from "ethers";
import { Link } from "react-router-dom"; // ✅ Use React Router's Link
import WhitepaperCard from "../components/WhitepaperCard";

const presaleAddress = "0xC2B9Dd791348D9C0a145f7E15455837a9d64E3F6";
const abi = [
  "function getStageInfo(uint8) view returns (uint256,uint256,uint256,uint256,uint256,uint256,bool,uint256,uint256)",
  "function buyWithETH(uint256,uint256) payable",
  "function buyWithUSDT(uint256)",
  "function buyWithUSDC(uint256)",
  "function amountRaised() view returns (uint256)",
  "function tokensSold() view returns (uint256)",
  "function currentStage() view returns (uint8)",
  "function getLatestETHPrice() view returns (uint256)",
  "function stages(uint8) view returns (uint256,uint256,uint256,uint256,uint256,uint256,bool,uint256,uint256)"
];

export default function Home() {
  const [stage, setStage] = useState("Loading...");
  const [price, setPrice] = useState(null);
  const [timeLeft, setTimeLeft] = useState("Loading...");
  const [progress, setProgress] = useState(0);
  const [raised, setRaised] = useState(0);
  const [hardcap, setHardcap] = useState(91000000); // $91M hardcap
  const [tokensSold, setTokensSold] = useState(0);
  const [totalTokens] = useState(30000000000); // 30B tokens

  useEffect(() => {
    const provider = new ethers.providers.JsonRpcProvider("https://eth-mainnet.g.alchemy.com/v2/kaATe5M132ftD-hnmk2ymOYgRkt3uWnN");
    const contract = new ethers.Contract(presaleAddress, abi, provider);

    async function fetchAllStages() {
      let totalRaised = 0;
      let totalTokensSold = 0;
      let totalHardcap = 0;
      let currentStage = null;
      let stagePrice = null;
      let secondsLeft = null;
      const now = Math.floor(Date.now() / 1000);

      for (let i = 1; i <= 3; i++) {
        try {
          const data = await contract.getStageInfo(i);
          const stageStart = Number(data[4]);
          const stageEnd = Number(data[5]);
          const stageActive = data[6];
          const stagePriceRaw = Number(data[0]);
          const stageRaised = Number(data[8]);
          const stageHardcap = Number(data[3]);
          const stageSold = Number(data[7]);

          totalRaised += stageRaised;
          totalTokensSold += stageSold;
          totalHardcap += stageHardcap;

          if (!currentStage && stageActive && now >= stageStart && now < stageEnd) {
            currentStage = i === 1 ? "Seed Sale" : i === 2 ? "Private Sale" : "Public Sale";
            stagePrice = (stagePriceRaw / 1e18).toFixed(3);
            secondsLeft = stageEnd - now;
            const d = Math.floor(secondsLeft / 86400);
            const h = Math.floor((secondsLeft % 86400) / 3600);
            const m = Math.floor((secondsLeft % 3600) / 60);
            setTimeLeft(`${d}d ${h}h ${m}m`);
          }
        } catch (err) {
          console.error("Failed to fetch stage", i, err);
        }
      }

      setRaised(totalRaised / 1e18);
      setTokensSold(totalTokensSold / 1e18);
      setHardcap(totalHardcap / 1e18);
      setProgress(((totalRaised / totalHardcap) * 100).toFixed(1));
      setStage(currentStage || "All Stages Complete");
      setPrice(stagePrice || "0.001");
    }

    fetchAllStages();
  }, []);

  return (
    <div className="px-6 py-10 max-w-5xl mx-auto text-white">
      <section className="text-center">
        <h1 className="text-4xl md:text-5xl font-bold mb-4">
          Welcome to MediCoin ICO 🎉
        </h1>
        <p className="text-lg md:text-xl text-gray-300 mb-6">
          Powering the MediCureOn ecosystem with secure, decentralized healthcare utility.
        </p>

        <div className="bg-gradient-to-r from-green-500/20 to-emerald-500/20 border-2 border-green-400 rounded-xl p-4 mb-8 shadow-lg">
          <p className="text-green-300 font-bold text-lg md:text-xl mb-2">
            🚀 MediCoin ICO is LIVE
          </p>
          <p className="text-green-200 font-semibold text-base md:text-lg">
            LP Launch in 7 Days – Get MCN at 1/5 of Listing Price
          </p>
        </div>

        <div className="bg-[#1a1a2e] p-6 rounded-2xl shadow-lg">
          <p className="text-lg">🔥 Current Stage: <strong>{stage}</strong></p>
          <p className="text-xl font-bold mt-2">1 MCN = ${price}</p>
          <p className="text-sm text-gray-400 mt-2">
            {stage} Ends In: <span className="font-semibold text-white">{timeLeft}</span>
          </p>

          <div className="w-full bg-gray-700 rounded-full h-3 mt-4 overflow-hidden">
            <div
              className="bg-purple-500 h-full rounded-full"
              style={{ width: `${progress}%` }}
            ></div>
          </div>

          <p className="text-sm text-gray-400 mt-2">
            Total Raised: ${raised.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} / ${hardcap.toLocaleString('en-US')}
          </p>
          <p className="text-sm text-gray-400">
            Total Tokens Sold: {tokensSold.toLocaleString('en-US')} / {totalTokens.toLocaleString('en-US')} MCN
          </p>
        </div>

        {/* ✅ Use React Router's Link to avoid mobile routing issues */}
        <div className="mt-6">
          <Link
            to="/presale"
            className="inline-block bg-gradient-to-r from-purple-500 to-indigo-600 text-white px-5 py-2 rounded-xl text-sm font-semibold hover:brightness-110 transition"
          >
            Buy Now →
          </Link>
        </div>

        <div className="mt-8 bg-gradient-to-r from-blue-600/20 to-cyan-600/20 border-2 border-blue-400/50 rounded-xl p-6 shadow-lg">
          <p className="text-blue-300 font-bold text-lg mb-3">
            📜 Official Contract Address
          </p>
          <div className="bg-[#1a1a2e] rounded-lg p-3 mb-4 font-mono text-sm text-blue-100 break-all">
            0x62217F8c102A33b6112C8B5B897BB9ee400737a5
          </div>
          <a
            href="https://etherscan.io/token/0x62217F8c102A33b6112C8B5B897BB9ee400737a5"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-gradient-to-r from-blue-500 to-cyan-500 text-white px-4 py-2 rounded-lg text-sm font-semibold hover:brightness-110 transition"
          >
            🔗 View on Etherscan →
          </a>
          <p className="text-blue-200 text-xs mt-3">
            Always verify our official contract address before purchasing tokens. Never trust unverified contracts.
          </p>
        </div>

        <WhitepaperCard />
      </section>
    </div>
  );
}
